import { Injectable } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Config, Path } from "../../../enums";
import { isEmptyField } from "../../../modules/shared";
import { InitService } from "../../../parsers/init.service";


@Injectable({
  providedIn: 'root'
})
export class ChangePasswordResolverService implements Resolve<any> {
  constructor(private route: ActivatedRoute, private initSrv: InitService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Observable(observer => {
      let loginConfig = {
        path: Path.CHANGE_PASSWD_CONFIG_PATH,
        configType: Config.CHANGE_PASSWD_CONFIG
      }
      const existingConfig = this.initSrv.getConfig(loginConfig.configType);
      if (isEmptyField(existingConfig)) {
        this.initSrv.loadConfig(loginConfig).then(() => {
          observer.next(true);
          observer.complete();
        }, () => {
          observer.next(false);
          observer.complete();
        });
      } else {
        observer.next(false);
        observer.complete();
      }
    });
  }
}
